import { render, staticRenderFns } from "./ItsStockBulkPackInBound.vue?vue&type=template&id=cd66c5f2&scoped=true&"
import script from "./ItsStockBulkPackInBound.vue?vue&type=script&lang=js&"
export * from "./ItsStockBulkPackInBound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd66c5f2",
  null
  
)

export default component.exports